import { generatePath } from 'react-router-dom';
import { SEARCH_DICTIONARY_SYNONYM_DETAIL_URL_PATH } from '../../../constants/service/common/urlConstants';

/** 규칙 상세 주소 — 경로 상수 한 곳만 고치면 목록·모달·경고 링크가 같이 따라온다 */
export const ruleDetailUrl = (ruleId: string): string =>
  generatePath(SEARCH_DICTIONARY_SYNONYM_DETAIL_URL_PATH, { id: ruleId });

/** 상세에서 「목록」 으로 돌아갈 때 — 들어올 때의 목록 URL(필터·페이지 포함)을 들고 다닌다 */
export type ListReturnState = { listUrl?: string };
